import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllProjectDeliveryPackagesPage } from "src/components/views/erp/project/delivery/AllProjectDeliveryPackagesPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/allDeliveryPackages")({
	staticData: { title: i18n.t("all_packages"), legacyViewKey: "allProjectDeliveryPackagesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllProjectDeliveryPackagesPage />;
}
